import React from "react";

const DashboardHome = () => {
  return (
    <div style={{ width: "100%", padding: "24px", overflow: "hidden"  }}>
      <h1 style={{ fontSize: "28px", fontWeight: "bold", textAlign: "center" }}>Welcome to the world of T24</h1>
      <p style={{ textAlign: "center", color: "#555" }}>Explore my AI agent</p>

      <div style={{ marginTop: "20px", width: "100%" }}>
        <iframe
          src="https://qwen-qwen3-vl-demo.hf.space"
          width="100%"
          height="900px"
          style={{ border: "none", borderRadius: "10px"}}
          title="T24 AI Agent"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default DashboardHome;
